import { type ViewStyle } from 'react-native'

import { COLOR_BRAND_BLACK_400, COLOR_BRAND_ORANGE_500, COLOR_WHITE } from '@/lib/colors'

export const blackBottomSheetModalBackgroundStyle: ViewStyle = { backgroundColor: COLOR_BRAND_BLACK_400 }
export const blackBottomSheetModalHandleStyle: ViewStyle = {
  backgroundColor: COLOR_BRAND_BLACK_400,
  borderRadius: 20
}
export const blackBottomSheetModalHandleIndicatorStyle: ViewStyle = {
  backgroundColor: COLOR_WHITE
}
export const redBottomSheetModalBackgroundStyle: ViewStyle = { backgroundColor: COLOR_BRAND_ORANGE_500 }
export const redBottomSheetModalHandleStyle: ViewStyle = {
  backgroundColor: COLOR_BRAND_ORANGE_500,
  borderRadius: 20
}
export const redBottomSheetModalHandleIndicatorStyle: ViewStyle = {
  backgroundColor: COLOR_WHITE
}
